export  const ConnectorConstant = {
    CONNECTOR_SAGA: "CONNECTOR_SAGA",
    CONNECTOR_REQUEST: "CONNECTOR_REQUEST",
    CONNECTOR_RESPONSE: "CONNECTOR_RESPONSE",
    CONNECTOR_API: "/get-connectors",

    CONNECTOR_BULK_EXCEL_API: "/get-connectors",

  
    ADD_CONNECTOR_SAGA: "ADD_CONNECTOR_SAGA",
    ADD_CONNECTOR_REQUEST: "ADD_CONNECTOR_REQUEST",
    ADD_CONNECTOR_RESPONSE: "ADD_CONNECTOR_RESPONSE",
    ADD_CONNECTOR_API: "/add-connectors",

    POST_CONNECTOR_BULK_SAGA: "POST_CONNECTOR_BULK_SAGA",
    POST_CONNECTOR_BULK_REQUEST: "POST_CONNECTOR_BULK_REQUEST",
    POST_CONNECTOR_BULK_RESPONSE: "POST_CONNECTOR_BULK_RESPONSE",
    POST_CONNECTOR_BULK_API: "/import-connectors",

    DELETE_CONNECTOR_API: "/delete-admin-connector/:id",
    DELETE_CONNECTOR_REQUEST: "DELETE_CONNECTOR_REQUEST",
    DELETE_CONNECTOR_RESPONSE: "DELETE_CONNECTOR_RESPONSE",
    DELETE_CONNECTOR_SAGA: "DELETE_CONNECTOR_SAGA",

    EDIT_CONNECTOR_API: "/edit-connectors/:id",

  };
  